export default {
  'menu.CompanyServiceNewPage': '新增场所服务',
}